import React from "react";
import { Backdrop, CircularProgress, Typography, Box } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { createTheme } from "@mui/material/styles";

const theme = createTheme();

const useStyles = makeStyles(() => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
    flexDirection: "column", // stack vertically
    display: "flex",
  },
  message: {
    marginTop: "20px",
  },
}));

export default function SimpleBackdrop({ message }) {
  const classes = useStyles();

  return (
    <Backdrop className={classes.backdrop} open={true}>
      <CircularProgress color="inherit" />
      {message && (
        <Typography variant="h6" style={{
          marginTop:'20px'
        }} >
          {message}
        </Typography>
      )}
    </Backdrop>
  );
}
